(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-article-grid"] && !Shopify.designMode) return;
  try {
    
  // Top-up: when the server-side scan (newest 50 posts) found fewer cards than wanted,
  // fetch the tag's real listing as JSON and append the missing ones.
  (function () {
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var card = function (a, o) {
      var meta = '';
      if (o.showTag) { for (var i = 0; i < (a.tags || []).length; i++) { if (a.tag_handles[i] !== o.tag) { meta = a.tags[i].toUpperCase(); break; } } }
      if (o.showRead) { var m = Math.max(1, Math.ceil((a.words || 0) / 200)); meta += (meta ? ' · ' : '') + m + ' MIN READ'; }
      var img = a.image ? '<img class="pg-acard__img" src="' + esc(a.image) + '" alt="' + esc(a.image_alt || a.title) + '" loading="lazy">' : '';
      return '<a class="pg-acard" href="' + esc(a.url) + '" style="--pg-acard-img-h:' + o.imgH + 'px;">' +
        '<div class="pg-acard__media">' + img + '</div>' +
        '<div class="pg-acard__body"><div class="pg-acard__title">' + esc(a.title) + '</div>' +
        (meta ? '<div class="pg-acard__meta">' + esc(meta) + '</div>' : '') + '</div></a>';
    };
    document.querySelectorAll('[data-pg-agrid][data-pg-feed]').forEach(function (grid) {
      if (grid.dataset.pgDone) return;
      grid.dataset.pgDone = '1';
      var have = parseInt(grid.dataset.pgHave, 10) || 0;
      var want = parseInt(grid.dataset.pgWant, 10) || 4;
      var opts = { tag: grid.dataset.pgTag, showTag: grid.dataset.pgShowTag === 'true', showRead: grid.dataset.pgShowRead === 'true', imgH: grid.dataset.pgImgH || 208 };
      var empty = grid.parentNode.querySelector('[data-pg-agrid-empty]');
      fetch(grid.dataset.pgFeed, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (t) {
          var data = JSON.parse(t);
          var list = (data.articles || []).slice(have, want);
          if (list.length) { grid.insertAdjacentHTML('beforeend', list.map(function (a) { return card(a, opts); }).join('')); }
          if (empty) { empty.hidden = grid.children.length > 0; }
        })
        .catch(function () { /* keep whatever the server rendered */ });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-article-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pg-hero').forEach(function (root) {
    if (root.dataset.pgHeroInit) return; root.dataset.pgHeroInit = '1';
    var open = root.querySelector('[data-pg-video-open]');
    var modal = root.querySelector('[data-pg-video-modal]');
    if (!open || !modal) return;
    var media = modal.querySelector('[data-pg-video-kind]');
    function show() {
      var kind = media.dataset.pgVideoKind, src = media.dataset.pgVideoSrc;
      media.innerHTML = kind === 'iframe'
        ? '<iframe src="' + src + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Video"></iframe>'
        : '<video src="' + src + '" controls autoplay playsinline></video>';
      modal.hidden = false; document.documentElement.style.overflow = 'hidden';
    }
    function hide() { modal.hidden = true; media.innerHTML = ''; document.documentElement.style.overflow = ''; }
    open.addEventListener('click', show);
    modal.querySelectorAll('[data-pg-video-close]').forEach(function (el) { el.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) hide(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-article-links"] && !Shopify.designMode) return;
  try {
    
  // Top-up: when the server-side scan (newest 50 posts) found fewer links than wanted,
  // fetch the tag's real listing as JSON and append the missing ones.
  (function () {
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var item = function (a, o) {
      var meta = '';
      if (o.showTag) { for (var i = 0; i < (a.tags || []).length; i++) { if (a.tag_handles[i] !== o.tag) { meta = a.tags[i].toUpperCase(); break; } } }
      if (o.showRead) { var m = Math.max(1, Math.ceil((a.words || 0) / 200)); meta += (meta ? ' · ' : '') + m + ' MIN READ'; }
      return '<li class="pg-alinks__item"><a class="pg-alinks__link" href="' + esc(a.url) + '">' + esc(a.title) + '</a>' +
        (meta ? '<span class="pg-alinks__meta">' + esc(meta) + '</span>' : '') + '</li>';
    };
    document.querySelectorAll('[data-pg-alinks][data-pg-feed]').forEach(function (list) {
      if (list.dataset.pgDone) return;
      list.dataset.pgDone = '1';
      var have = parseInt(list.dataset.pgHave, 10) || 0;
      var want = parseInt(list.dataset.pgWant, 10) || 12;
      var opts = { tag: list.dataset.pgTag, showTag: list.dataset.pgShowTag === 'true', showRead: list.dataset.pgShowRead === 'true' };
      var root = list.closest('.pg-alinks');
      var box = root && root.querySelector('[data-pg-alinks-box]');
      var empty = root && root.querySelector('[data-pg-alinks-empty]');
      fetch(list.dataset.pgFeed, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (t) {
          var data = JSON.parse(t);
          var rest = (data.articles || []).slice(have, want);
          if (rest.length) { list.insertAdjacentHTML('beforeend', rest.map(function (a) { return item(a, opts); }).join('')); }
          var any = list.children.length > 0;
          if (box) { box.hidden = !any; }
          if (empty) { empty.hidden = any; }
        })
        .catch(function () {
          var any = list.children.length > 0;
          if (box) { box.hidden = !any; }
          if (empty) { empty.hidden = any; }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pg-faq').forEach(function (root) {
    if (root.dataset.pgFaqInit) return; root.dataset.pgFaqInit = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pg-faq-toggle]');
      if (!btn || !root.contains(btn)) return;
      var item = btn.closest('.pg-faq__item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('.pg-faq__sign').textContent = open ? '−' : '+';
    });
  });
  /* theme editor: open the block being edited */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('.pg-faq__item') : null;
    if (item) { item.classList.add('is-open'); var b = item.querySelector('[data-pg-faq-toggle]'); if (b) { b.setAttribute('aria-expanded', 'true'); b.querySelector('.pg-faq__sign').textContent = '−'; } }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-product-compare"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pg-cmp').forEach(function (root) {
    if (root.dataset.pgCmpInit) return; root.dataset.pgCmpInit = '1';
    var el = root.querySelector('[data-pg-cmp-scroller]');
    if (!el) return;
    var step = (parseInt(getComputedStyle(root).getPropertyValue('--pg-cmp-col-w'), 10) || 218) + 12;
    var prev = root.querySelector('[data-pg-cmp-prev]'), next = root.querySelector('[data-pg-cmp-next]');
    if (prev) prev.addEventListener('click', function () { el.scrollLeft -= step; });
    if (next) next.addEventListener('click', function () { el.scrollLeft += step; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pg-rev').forEach(function (root) {
    if (root.dataset.pgRevInit) return; root.dataset.pgRevInit = '1';
    var el = root.querySelector('[data-pg-rev-scroller]');
    var prev = root.querySelector('[data-pg-rev-prev]');
    var next = root.querySelector('[data-pg-rev-next]');
    if (!el) return;
    if (prev) prev.addEventListener('click', function () { el.scrollLeft -= 320; });
    if (next) next.addEventListener('click', function () { el.scrollLeft += 320; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-stage-cards"] && !Shopify.designMode) return;
  try {
    
  // Smooth-scroll the stage cards to their anchor without turning on scroll-behaviour for
  // the whole host theme. The hash is still pushed so the URL stays shareable.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.pg-stages__card[data-pg-anchor]');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('data-pg-anchor'));
    if (!target) return;
    e.preventDefault();
    var startY = window.scrollY;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // Smooth scrolling is skipped by some browsers/settings (reduced motion, hidden tabs):
    // if nothing moved shortly after, jump there instead so the card always works.
    setTimeout(function () { if (Math.abs(window.scrollY - startY) < 2) target.scrollIntoView({ block: 'start' }); }, 500);
    if (history.pushState) history.pushState(null, '', '#' + a.getAttribute('data-pg-anchor'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
